import boletaApi from "./boletaApi";

export const getInvoices = async () => {
  try {
    return await boletaApi.get("/getInvoices");
  } catch (error) {
    const { response } = error;
    return response;
  }
};
